import { render } from "./FaqIndex.vue?vue&type=template&id=36fd5c82&scoped=true"
import script from "./FaqIndex.vue?vue&type=script&lang=js"
export * from "./FaqIndex.vue?vue&type=script&lang=js"

import "./FaqIndex.vue?vue&type=style&index=0&id=36fd5c82&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36fd5c82"]])

export default __exports__